<template>
  <div class="LoadingComponent">
    <!-- The colour is a literal on purpose: it lands in an SVG attribute,
         where a CSS variable is not resolved. Keep it in sync with the
         --color-accent token of the design system. -->
    <custom-loading-component
      :active.sync="isLoadingFromAPI"
      :can-cancel="false"
      :is-full-page="true"
      color="#2b4fd2">
    </custom-loading-component>
  </div>
</template>

<script>
export default {
  name: 'LoadingComponent',
  computed : {
    isLoadingFromAPI: {
      get () {
        return this.$store.state.isAPILoading
      }
    },
  }
}
</script>
